import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusTranslationKey, StatusType } from '@/types/status';

export const useStatus = (
  translationNameSpace: string,
  status?: StatusTranslationKey,
  statusDescriptionMap?: Partial<Record<StatusTranslationKey, ReactNode>>,
) => {
  const { t } = useTranslation('status');

  if (!status) return {};

  const statusDescription =
    statusDescriptionMap && statusDescriptionMap[status]
      ? statusDescriptionMap[status]
      : t(`${translationNameSpace}.${status}.description`);

  return {
    statusType: StatusType[status],
    statusTitle: t(`${translationNameSpace}.${status}.title`),
    statusDescription,
  };
};
